import OutputViewerSection from '../OutputViewerSection';
import ValueWithDependencies from './configurationSection/ValueWithDependencies.jsx';
import replaceValuesWithDependencies from './configurationSection/replaceValuesWithDependencies.jsx';
import DataViewer from '@/components/DataViewer';
import { useSelector } from 'react-redux';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import Panel from '@/components/panel/Panel';

const ConfigurationSection = ({ request = {}, dependencies = {} }) => {
  const actionArguments = useSelector((state) => workflowScreenSelectors.activeWorkflowStepAppAction(state)?.arguments);

  const { arguments: args } = request;
  const argDependencies = args?.dependencies;

  const combinedArgs = {
    ...(args?.query || {}),
    ...(args?.params || {}),
    ...(args?.body || {}),
    ...(args?.custom || {})
  };

  const argumentsWithDependencies = Object.entries(combinedArgs).reduce((acc, [key, value]) => {
    const argumentDefinition = actionArguments?.find((arg) => arg?.key === key);
    if (!argumentDefinition) {
      return acc;
    }
    const argumentName = argumentDefinition.name || key;
    const valueDependencies = argDependencies?.[key];
    if (valueDependencies && Array.isArray(valueDependencies) && valueDependencies.length > 0 && typeof value === 'string') {
      acc[argumentName] = <ValueWithDependencies value={value} dependencies={valueDependencies} />;
    } else {
      // Handle Uint8Array or other ArrayBuffer views
      if (value && typeof value === 'object' && value.buffer instanceof ArrayBuffer && typeof value.BYTES_PER_ELEMENT === 'number') {
        const limited = Array.from(value.slice(0, 20));
        acc[argumentName] = value.length > 20 ? [...limited, '...(Limited for performance)'] : value;
        return acc;
      }
      acc[argumentName] = value;
    }
    return acc;
  }, {});

  const postProcessingSortWithDependencies = replaceValuesWithDependencies(dependencies?.options?.postProcessing?.sort);
  const postProcessingSliceWithDependencies = replaceValuesWithDependencies(dependencies?.options?.postProcessing?.slice);
  const memoryWithDependencies = replaceValuesWithDependencies(dependencies?.options?.memory);
  const cacheWithDependencies = replaceValuesWithDependencies(dependencies?.options?.cache);
  const paginationWithDependencies = replaceValuesWithDependencies(dependencies?.options?.pagination);
  const flowControlWithDependencies = replaceValuesWithDependencies(dependencies?.options?.flowControl);

  if (Object.keys(argumentsWithDependencies).length === 0 && Object.keys(dependencies).length === 0) {
    return null;
  }

  return (
    <>
      <OutputViewerSection className={'configuration py-2'}>
        {Object.keys(argumentsWithDependencies).length > 0 && <DataViewer data={argumentsWithDependencies} />}
        {paginationWithDependencies && (
          <Panel.Section title="Options" collapsable={true}>
            <DataViewer data={{ pagination: paginationWithDependencies }} collapsed={100} />
          </Panel.Section>
        )}
        {(postProcessingSortWithDependencies || postProcessingSliceWithDependencies) && (
          <Panel.Section title="Transform Response" collapsable={true}>
            {postProcessingSortWithDependencies && <DataViewer data={{ sort: postProcessingSortWithDependencies }} collapsed={100} />}
            {postProcessingSliceWithDependencies && <DataViewer data={{ slice: postProcessingSliceWithDependencies }} collapsed={100} />}
          </Panel.Section>
        )}
        {(memoryWithDependencies || cacheWithDependencies || flowControlWithDependencies) && (
          <Panel.Section title="Step Completion Options" collapsable={true}>
            {cacheWithDependencies && <DataViewer data={{ cache: cacheWithDependencies }} collapsed={100} />}
            {flowControlWithDependencies && <DataViewer data={{ flowControl: flowControlWithDependencies }} collapsed={100} />}
            {memoryWithDependencies && <DataViewer data={{ memory: memoryWithDependencies }} collapsed={100} />}
          </Panel.Section>
        )}
      </OutputViewerSection>
    </>
  );
};

export default ConfigurationSection;
